import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import OrderProp from '../../../shop/propTypes/orderProp';
import DetailItem from '../../../shop/detail/DetailItem';
import { formatDate } from '../../../../services/dateUtilityFunctions';
import UsersContainer from './UsersContainer';
import AddressSection from './AddressSection';
import ShippingSection from './ShippingSection';

function MainSection(props) {
  const { t, opportunity } = props;

  const { billingAddress, shippingAddress, installationAddress, shipping } =
    opportunity;

  return (
    <div className="sub-section">
      <UsersContainer opportunity={opportunity} />
      <AddressSection address={billingAddress} title={t('billing_address')} />
      <AddressSection
        address={shippingAddress}
        title={t('shop.cart.shipping')}
      />
      <AddressSection
        address={installationAddress}
        title={t('order_installationAddress')}
      />
      <ShippingSection
        shipping={shipping}
        title={t('order_detail_right.shipping')}
        wrapperClass="shipping-fields"
      />
    </div>
  );
}

MainSection.propTypes = {
  t: PropTypes.func.isRequired,
  opportunity: PropTypes.shape(OrderProp.propType).isRequired,
};

export default translate(MainSection);
